module.exports = __webpack_public_path__ + "static/singing-ff21e2e3c56d6190e3516dfb7293f7ea.mp3";